"use client"
import React, { createContext, useMemo } from "react"
import { TableSize } from "./constants"

export const TableContext = createContext<{
  size: TableSize
  dividers?: boolean
}>({
  size: "md",
  dividers: false,
})

type Props = {
  size: TableSize
  dividers?: boolean
  children: React.ReactNode
}

export const TableProvider = ({ size, dividers, children }: Props) => {
  const value = useMemo(() => ({ size, dividers }), [size, dividers])

  return <TableContext.Provider value={value}>{children}</TableContext.Provider>
}
